import { render, staticRenderFns } from "./CampaignStatusIcon.vue?vue&type=template&id=6f8f5323&"
import script from "./CampaignStatusIcon.vue?vue&type=script&lang=ts&"
export * from "./CampaignStatusIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports